import React, { MouseEventHandler, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Icon } from '../../icons/Icon';
import styles from './DropdownField.module.scss';

export const DropdownField = ({
    active, onClick, children, className
}: Props) => {

    const { t } = useTranslation();
    const classes = classNames(styles.container, className, {
        [styles.active]: active,
        'idt-active-toggleable': active,
        'idt-inactive': !active
    });

    return (
        <div className={classes} onClick={onClick}
            title={active ? t('commons.collapse') : t('commons.expand')}>
            <div className={styles.default}>
                <div className={styles.field}>
                    {children}
                </div>
                <div className={styles.button}>
                    <Icon className={styles.buttonIcon}
                        type={active ? 'general-ui-chevron-up' : 'general-ui-chevron-down'} />
                </div>
            </div>
        </div>
    );
};

type Props = PropsWithChildren<{
    active: boolean;
    onClick: MouseEventHandler;
    src?: string;
    className?: string;
}>;